import axios from 'axios';
import { Feed } from 'views/bluviu-nutrition/types/feed.type';

/**
 * Returns active feeds for a scenario
 * @param globalCompanyId
 * @returns
 */
export const getFeeds = async (globalCompanyId: string): Promise<Feed[]> => {
  const res = await axios.get<Feed[]>(`/ewosapi/v1/scenario/feeds?globalCompanyId=${globalCompanyId}`);
  return res.data;
};
